import { render, staticRenderFns } from "./DeliveryBasisDialog.vue?vue&type=template&id=51dcc7ca&"
import script from "./DeliveryBasisDialog.vue?vue&type=script&lang=js&"
export * from "./DeliveryBasisDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports